export const btnRendererZoomAcceptRequest = {
    template: `
      <span >
        <button class="btn-sm btn-secondary">Req Zoom Accept</button>
      </span>
    `
}

export const btnRendererExtendClass = {
    template: `
      <span v-if="params.data.assignCount <= params.data.countAttended">
        <button color="primary"  class="btn-sm btn-info ">Extend Class</button>
      </span>
    `
}


export const btnRendererSentFee = {
    template: `
      <span v-if="(params.data.isSentFee === false || params.data.isSentFee === 'N')
                    && params.data.assignStatus === 'ACTIVE'">
        <button color="primary"  class="btn-sm btn-primary ">Sent Fee</button>
      </span>
    `
}

export const btnRendererSave = {
    template: `<span><button color="primary"  class="btn-sm btn-primary ">Save</button></span>`
}
export const btnRendererComplete = {
    template: `
      <span v-if="params.data.assignStatus === 'ACTIVE' && params.data.assignCount - params.data.countCalculated < 1 ">
        <button color="primary"  class="btn-sm btn-primary ">Complete</button>
      </span>
    `
}
